import Axios from 'axios'
import requestPrefix from '../requestPrefix'

export default {
  // 保存
  mobileReportBillContentSave(data) {
    return Axios({
      url: requestPrefix.projectUrl + '/reportBillContent/save',
      method: 'post',
      data: data
    })
  },
  // 详情
  mobileReportBillContentGetById(data) {
    return Axios({
      url: requestPrefix.projectUrl + '/reportBillContent/getByBillId',
      method: 'get',
      params: data
    })
  }

}



// WEBPACK FOOTER //
// ./src/api/reportBillContent/index.js